import { getQueryParam } from './location';

const hasTouchScreen: boolean = (
  'ontouchstart' in window || navigator.maxTouchPoints > 0
);

const supportsApplePay = (() => {
  try {
    return !!window.ApplePaySession
        && window.ApplePaySession.supportsVersion(3)
        && window.ApplePaySession.canMakePayments();
  } catch (err) {
    return false;
  }
})();

const runsIos = /iP(ad|hone)/i.test(window.navigator.userAgent);

const runsSafari = !!window.navigator.userAgent.match(
  /Version\/[\d.]+.*Safari/,
);

const runsWebview = !!window.ReactNativeWebView
  || !!getQueryParam('__simulate_app');

export { hasTouchScreen, supportsApplePay, runsIos, runsSafari, runsWebview };
